import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3035b8fd/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`These sites include guidance and resources for IBM product teams, and are currently accessible to IBMers only.`}</p>
    </PageDescription>
    <h2>{`Product-specific guidance`}</h2>
    <p>{`The guidance and resources here are for IBM product teams building software applications and digital experiences with the Carbon Design System. This work is built on the foundation of Carbon and provides solutions for specific domains and use cases.`}</p>
    <p><em parentName="p">{`This content is accessible to IBMers only.`}</em></p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Cloud Data & AI" href="https://pages.github.ibm.com/cdai-design/pal/" mdxType="ResourceCard">
          <img {...{
            "src": "/c059e51265c242dc2f922c8229ce7e13/ibm-cloud.svg",
            "alt": "Data icon"
          }}></img>
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Cloud Pattern and Asset Library" href="https://pages.github.ibm.com/ibmcloud/pal/" mdxType="ResourceCard">
          <img {...{
            "src": "/c059e51265c242dc2f922c8229ce7e13/ibm-cloud.svg",
            "alt": "Cloud icon"
          }}></img>
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Watson Health" href="https://pages.github.ibm.com/Watson-Health/index.html" mdxType="ResourceCard">
          <img {...{
            "src": "/cd9e2a434f8cc591bfe11b97ad1764e3/watson.svg",
            "alt": "Pattern icon"
          }}></img>
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Watson IoT Design" href="https://pages.github.ibm.com/Watson-IoT/IoT-Design-Site/" mdxType="ResourceCard">
          <img {...{
            "src": "/cd9e2a434f8cc591bfe11b97ad1764e3/watson.svg",
            "alt": "IoT icon"
          }}></img>
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Brand guidance`}</h2>
    <p>{`The IBM brand systems have been developed for various IBM businesses, audiences, categories, and offerings. Read them to understand the rationale behind every visual and verbal detail, so that the guidance may inform your work.`}</p>
    <p><em parentName="p">{`This content is accessible to IBMers only.`}</em></p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="IBM Brand Systems" href="https://www.ibm.com/brand/systems" mdxType="ResourceCard">
          <img {...{
            "src": "/861b9a29a58f4581b945d88efdf050f6/bee.svg",
            "alt": "Bee icon"
          }}></img>
  </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      